import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearManagementReportAccess } from '../../utils/managementReportAccess';
import { clearScreenPopAccess } from '../../utils/screenPopAccess';


interface AdminHeaderProps {
  onMenuClick: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ onMenuClick }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_username');
    localStorage.removeItem('admin_role');
    clearManagementReportAccess();
    clearScreenPopAccess();
    navigate('/admin/login');
  };

  const username = localStorage.getItem('admin_username');

  return (
    <header className="sticky top-0 z-20 h-14 border-b bg-white shadow-sm lg:hidden">
      <div className="mx-auto flex h-full max-w-7xl items-center justify-between px-4">
        <button
          type="button"
          onClick={onMenuClick}
          className="rounded-lg p-2 text-gray-600 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
          aria-label="باز کردن منو"
        >
          <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <p className="truncate text-sm font-semibold text-gray-900">
          {username || 'پنل مدیریت'}
        </p>

        <div className="w-10" aria-hidden />
      </div>
    </header>
  );
};

export default AdminHeader;
